(function() {
  var currentPageUrl = window.location.pathname,
      posPaymentSummary = currentPageUrl.indexOf('/payment/summary'),
      posOrderConfirm = currentPageUrl.indexOf('/checkout/orderConfirmation'),
      visitedOrderConfirm = 'visitedOrderConfirm',
      redirectToHome = 'redirectToHome';

  if (currentPageUrl.indexOf('/checkout/single/summary') !== -1) {
    sessionStorage.setItem(visitedOrderConfirm, 'false');
    sessionStorage.setItem(redirectToHome, 'false');
  }

  if (posPaymentSummary !== -1) {
    if (sessionStorage.getItem(redirectToHome) === 'true') {
      document.location = escape('/');
    }

    if (sessionStorage.getItem(visitedOrderConfirm) === 'true') {
      document.body.innerHTML = ' ';
      sessionStorage.setItem(redirectToHome, 'true');
      document.location = escape('/');
    }
  }

  if (posOrderConfirm !== -1) {
    sessionStorage.setItem(visitedOrderConfirm, 'true');
  }
})();
